import { useLayoutEffect } from 'react';
import { updateMetaTag, removeMetaTag } from './headManager';

export const useHeadTags = (data: { name?: string; content?: string; property?:string }[]) => {
    useLayoutEffect(() => {
        data.forEach(({ name, content, property }) => updateMetaTag(null, name, content, property));

        return () => {
            data.forEach(({ name, property }) => removeMetaTag(name, property));
        };
    }, [data]);
};
